import React, { useMemo } from 'react'
import TourOfferLoadTile from './TourOfferLoadTile'
import styled from 'styled-components'
import { fillArray, take } from 'lib/arrayUtils'
import FullWidthCarousel from 'components/Luxkit/Carousel/FullWidthCarousel'
import TourTileSkeletonLoader from 'components/Tours/TourTiles/TourTileSkeletonLoader'
import { useOfferList } from 'hooks/Offers/useOfferList'
import { OFFER_TYPE_TOUR_V2 } from 'constants/offer'
import BodyText from 'components/Luxkit/Typography/BodyText'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'

interface Props {
  placeId: string;
  categories?: Array<string>;
  sortBy?: App.OfferListSortByOptions;
  excludeIds?: Array<string>;
  limit?: number;
}

const Wrapper = styled.div`
  width: 100%;
`

function TourSearchTileList(props: Props) {
  const { placeId, categories, sortBy, excludeIds, limit = 8 } = props
  const filters = useMemo(() => ({
    destinationId: placeId,
    offerTypes: [OFFER_TYPE_TOUR_V2],
    categories,
    sortBy,
  }), [placeId, categories, sortBy])
  const [tourIds] = useOfferList(filters, { excludedIds: excludeIds })

  return <Wrapper>
    {!tourIds.fetching && tourIds.offerIds.length === 0 && <LayoutContainer><BodyText variant="medium">No tour available</BodyText></LayoutContainer>}
    <FullWidthCarousel gap={24} itemsPerArrow={4}>
      {tourIds.fetching && fillArray(4).map((_, index) => <TourTileSkeletonLoader key={index} />)}
      {take(tourIds.offerIds, limit).map((id: string, index: number) => (
        <TourOfferLoadTile
          key={id}
          id={id}
          index={index}
          lazyLoad
          categories={categories}
        />))}
    </FullWidthCarousel>
  </Wrapper>
}

export default TourSearchTileList
